<template>
    <div class="outer-wrapper">
        <div class="container">
            <div class="text-center">
                <h5 class="header-1"><b></b></h5>
                <img src="img/mobikwik_banner.png" />
                <div class="dear-cust-div1" style="text-align:center;">
                    <h3 style="margin:10px 0;">Doodhvale customers can get cashback of upto Rs 75/- while doing payments
                        from
                        their mobikwik wallet.
                        Please read the following term and conditions carefully of this offer.</h3>
                </div>
                <div class="dear-cust-div1" style="text-align:justify;">
                    <ul>
                        <li>Get up to Rs 75 Cashback on pay via Mobikwik wallet</li>
                        <li>Use Code: MBK75 on the Mobikwik Payment Page to avail the offer</li>
                        <li>Offer valid once per user in a month</li>
                        <li>Minimum Assured Cashback Rs.10</li>
                        <li>Offer valid on a minimum transaction of Rs 199.</li>
                        <li>Offer valid from 1st Nov'22 - 31Mar'23 </li>
                        <li>If the cashback is not received or any issue regarding this offer or transaction then plesse
                            contact to Mobikwik team. Doodhvale is not responsible for any issue or non receiving of
                            cashback.</li>
                        <li>This offer is exclusively offer by Mobikwik wallet only not any other instruments.</li>
                        <li>Cashback will come in mobikwik wallet only.</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    methods: {
    }
}
</script>
<style>
.membership p,
.bottomParaDiv p {
    text-align: justify;
}
</style>